import { Action, combineReducers, configureStore } from "@reduxjs/toolkit";
import { appStateSlice } from "./app-state/app-state-slice";
import { setupListeners } from "@reduxjs/toolkit/query/react";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "./types";
import { themeSlice } from "./theme/theme-slice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { chatSlice } from "./chat/chat-slice";
import { callsSlice } from "./calls/calls-slice";
import { themeSliceName } from "./theme/constants/theme-slice-name";
// @ts-ignore
import { encryptTransform } from "redux-persist-transform-encrypt";
import { ACTION_REVERT_ALL } from "./actions";
import { appStateSliceName } from "./app-state/constants";
import { getPersistConfig } from "redux-deep-persist";
import { chatSliceName } from "./chat/constants";

const encryptPipe = encryptTransform<any, any>({
  secretKey: process.env.LOCAL_STORAGE_ENCRIPTION_SECRET!,
});

export const applicationRootReducer = combineReducers({
  [appStateSlice.reducerPath]: appStateSlice.reducer,
  [themeSlice.reducerPath]: themeSlice.reducer,
  [chatSlice.reducerPath]: chatSlice.reducer,
  [callsSlice.reducerPath]: callsSlice.reducer,
});

export const storagePersistKey = "voa-root";

const rootPersistConfig = getPersistConfig({
  key: storagePersistKey,
  storage: storage,
  blacklist: [
    themeSliceName,
    `${appStateSliceName}.isReadyHeartbeat`,
    `${appStateSliceName}.isNudgeOpen`,
    `${appStateSliceName}.shouldDisplay`,
    `${appStateSliceName}.isChatWebsocketConnected`,
    `${chatSliceName}.inputCollection`,
  ],
  transforms: [encryptPipe],
  rootReducer: applicationRootReducer,
});

const persistedReducer = persistReducer(
  rootPersistConfig,
  applicationRootReducer
);

const reducerProxy = (state: any, action: Action) => {
  if (action.type === ACTION_REVERT_ALL) {
    return persistedReducer(undefined, action);
  }
  return persistedReducer(state, action);
};

export const store = configureStore({
  reducer: reducerProxy,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);


export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
